import React from 'react'
import { Form, Row, Col, Card, Typography, message } from 'antd'
import { useNavigate } from 'react-router-dom';
import { goBack } from 'assets/icons';
import styled from '@emotion/styled';
import CreateCampaignFooter from './CreateProductFooter';
import MainCreateCampaign from './MainCreateCampaign';
import { useCreateCampaign } from 'hooks/useCampaign';
import { CreateCampaignInput } from 'services/interface';
import { useAppSelector } from 'store';

const CreateCampaign = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { mutateAsync: createCampaign, isPending } = useCreateCampaign();
    const contact = useAppSelector((state) => state.auth.contact);

    const onFinish = async (values: any) => {
        try {
            const startDateIso = values.start_date ? new Date(values.start_date).toISOString() : null;
            const endDateIso = values.expire_date ? new Date(values.expire_date).toISOString() : null;

            const payload: CreateCampaignInput = {
                title: values.campaign_name,
                description: values.description ?? null,
                campaign_type: values.campaign_type,
                status: "active", // เป็น active เสมอ
                start_date: startDateIso as any,
                end_date: endDateIso,
                is_active: !values.is_disabled,
                factory_id: contact?.id || null, // เป็น factory ของฉันเสมอ
                max_usage: Number(values.max_usage ?? 0),
                max_usage_per_user: Number(values.max_usage_per_user ?? 1),
                remark: values.remark ?? null,
                conditions: [
                    {
                        condition_type: values.condition_type,
                        priority: 1,
                        products: (values.conditions ?? []).map((row: any, index: number) => ({
                            product_id: row.product_id,
                            sku_variant_id: row.sku_variant_id,
                            required_quantity: Number(row.quantity ?? 1),
                            priority: index + 1,
                        })),
                    },
                ],
                rewards: [],
            };

            if (values.result_type === 'free_product') {
                payload.rewards = [
                    {
                        reward_type: 'free_product',
                        quantity: 1,
                        priority: 1,
                        products: (values.free_gifts ?? []).map((row: any, index: number) => ({
                            product_id: row.product_id,
                            sku_variant_id: row.sku_variant_id,
                            quantity: Number(row.quantity ?? 1),
                            priority: index + 1,
                        })),
                    },
                ];
            } else {
                const unit = values.discount_unit === 'percentage' ? 'discount_percentage' : 'discount_amount';
                payload.rewards = [
                    {
                        reward_type: unit,
                        quantity: 1,
                        priority: 1,
                        discount_percentage: unit === 'discount_percentage' ? Number(values.discount_value ?? 0) : null,
                        discount_amount: unit === 'discount_amount' ? Number(values.discount_value ?? 0) : null,
                    },
                ];
            }

            await createCampaign(payload);
            message.success('สร้างแคมเปญสำเร็จ');
            navigate('/campaign');
        } catch (error: any) {
            message.error(error?.message || 'สร้างแคมเปญไม่สำเร็จ');
        }
    }
    const handleValuesChange = (changedValues: any, allValues: any) => {
        // เมื่อ campaign_type เปลี่ยน ให้อัพเดท result_type อัตโนมัติ
        if (changedValues.campaign_type) {
            const newResultType = changedValues.campaign_type === "buy_x_get_y" ? "free_product" : "discount";
            form.setFieldsValue({ result_type: newResultType });
        }
    };

    return (
        <Form form={form} onFinish={onFinish} onValuesChange={handleValuesChange}>
            <Row className="rowgap-vbox" gutter={[24, 0]}>
                <Col span={24}>
                    <Card bordered={false} className="criclebox h-full tabs-mobile">
                        <HeaderTabs>
                            <IconWrapper
                                onClick={() => {
                                    navigate("/campaign");
                                }}
                            >
                                <SpanIcon>{goBack}</SpanIcon>
                            </IconWrapper>
                            <Typography.Title level={5}>เพิ่มแคมเปญ</Typography.Title>
                            <RightIconWrapper></RightIconWrapper>
                        </HeaderTabs>
                        <WrapperAll>
                            <MainCreateCampaign
                                form={form}
                                onFinish={onFinish}
                            />
                        </WrapperAll>
                    </Card>
                </Col>
            </Row>
            <CreateCampaignFooter loading={isPending} />
        </Form>
    )
}

export default CreateCampaign

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;